var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h6',{staticStyle:{"margin":"0px !important"}},[_vm._v(_vm._s(_vm.GECIKENCEKTOPLAM))]),_c('p',{staticStyle:{"color":"#ea5455","margin":"0px !important"}},[_vm._v(_vm._s(_vm.PUANGCEK))])])
}
var staticRenderFns = []

export { render, staticRenderFns }